import { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MessageContextProvider } from '@/common/contexts/message-context/MessageContext';
import LanguageContextProvider from '@/common/contexts/LanguageContext';
import AudioRecordingContextProvider from '@/common/contexts/AudioRecordingContext';
import { GuestAuthProvider } from '@/common/contexts/GuestAuthContext';

const queryClient = new QueryClient();

interface AppProvidersProps {
	children: ReactNode;
}

const AppProviders = ({ children }: AppProvidersProps) => {
	return (
		<BrowserRouter>
			<QueryClientProvider client={queryClient}>
				<LanguageContextProvider>
					<MessageContextProvider>
						<AudioRecordingContextProvider>
							<GuestAuthProvider>{children}</GuestAuthProvider>
						</AudioRecordingContextProvider>
					</MessageContextProvider>
				</LanguageContextProvider>
			</QueryClientProvider>
		</BrowserRouter>
	);
};

export default AppProviders;
